// extracted by mini-css-extract-plugin
module.exports = {"dialog_mask_wrapper":"Dialog_dialog_mask_wrapper__1LTly","alert":"Dialog_alert__3Pu50","tabMenu":"Dialog_tabMenu__1xTXc"};